var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 60C73.71 60 69 55.29 69 49.5C69 43.71 73.71 39 79.5 39C85.29 39 90 43.71 90 49.5C90 55.29 85.29 60 79.5 60ZM79.5 45C77.02 45 75 47.0175 75 49.5C75 51.9825 77.02 54 79.5 54C81.98 54 84 51.9825 84 49.5C84 47.0175 81.98 45 79.5 45Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81.5275 91.7L51 47.295L20.4725 91.7L15.5275 88.3L51 36.705L86.4725 88.3L81.5275 91.7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5325 73.71L36.505 61.665L41.495 58.335L45.4675 64.29L51 58.7575L57 64.7575L60.8775 60.8775L65.1225 65.1225L57 73.2425L51 67.2425L44.5325 73.71Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99 93H21C16.0375 93 12 88.9625 12 84V36C12 31.0375 16.0375 27 21 27H99C103.963 27 108 31.0375 108 36V84C108 88.9625 103.963 93 99 93ZM21 33C19.345 33 18 34.345 18 36V84C18 85.655 19.345 87 21 87H99C100.655 87 102 85.655 102 84V36C102 34.345 100.655 33 99 33H21Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.e92e5e00.svg";
export { ForwardRef as ReactComponent };